import React, { Component, Fragment } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';

import styles from "../styles";

import Loading from '../helper/Loading';
import PageHeader from "../helper/PageHeader";
import Error from '../helper/Error';
import SimpleTable from '../helper/SimpleTable';
import DeleteDialog from '../helper/Dialogs';
import { authContext } from "../../context/AuthContext";

class LocationTemplates extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);

        this.state = {
            locTemplates: [],
            error: null,
            id: null,
            name: '',
            countyCode: '',
            city: '',
            street: '',
            stateCode: '',
            zipCode: '',
            mapURL: '',
            isDeleteDialogOpen: false,
            itemToDelete: ''
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/administration/locationTemplate');
    }

    onEdit = (tag) => {
        let id = tag;
        this.props.history.push('/administration/locationTemplate/' + id);
    }

    openDeleteDialog = (tag) => {
        this.setState({ itemToDelete: tag });
        this.handleDeleteDialogOpen();
    }

    onDelete = (event) => {
        // let id = event.currentTarget.getAttribute('data-tag');
        this.handleDeleteDialogClose();
        let id = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });
        let url = "/api/LocationTemplate/" + id;
        let token = sessionStorage.getItem('accessToken');

        axios(url,  {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.status === 200) {
                this.refresh();
            }
        });
    }

    refresh() {
        axios.get('/api/locationTemplate', {
        }).then((res) => {
            this.setState({
                locTemplates: res.data.locTemplates
            });
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    componentDidMount() {
        this.refresh();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    render() {
        const { classes } = this.props;
        const enableActions = this.context.roles.isClassroomTrainingAdmin === 1? true:false;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.error !== null) return <Error />;

        if (this.state.locTemplates.length === 0) return <Loading />;

        let enhancedData = [];
        enhancedData = this.state.locTemplates.map((arrayItem) => {
            let item = JSON.parse(JSON.stringify(arrayItem))
            item.address = item.street + ', ' + item.city + ', ' + item.stateCode + ' ' + item.zipCode;
            item.actionsDisabled = {
                edit: false,
                delete: false
            }
            return item;
        });

        const tableCells = [
            { id: 'name', label: 'Name', centered: false },
            { id: 'address', label: 'Address', centered: false }
        ];

        const actionButtons = [
            { icon: "edit", action: this.onEdit, delete: false },
            { icon: "delete", action: this.openDeleteDialog, delete: true }
        ];

        return (
            <Fragment>
                <PageHeader
                    title={"Templates - Location"}
                    actionButtons={[{ label: "Add New Location", action: this.onNew, disabled: enableActions === false }]}
                />

                <div>
                    <div className={classes.root}>
                        <div>
                            <br />

                            <SimpleTable
                                data={enhancedData}
                                cellKey={"ID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={enableActions}
                            />
                            <DeleteDialog
                                open={this.state.isDeleteDialogOpen}
                                onClose={this.handleDeleteDialogClose}
                                onDelete={this.onDelete}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// export default LocationTemplates;
export default withStyles(styles, { withTheme: true })(LocationTemplates);
